import type {MakeRequest, RestResponse} from './request'
import type {
  CACategoryDataModel,
  CACategoryModel,
  CatalogFieldDependentResponse,
  FieldsModel,
} from '../models'
import type {AppStorage} from '../index'
import type {Secure} from '../helpers/userSecure'
import {dataResponseConverter} from './request'

export class CategoriesApi {
  constructor(
    private makeRequest: MakeRequest,
    private storage: AppStorage,
    private secure: Secure,
  ) {}

  suggestSearchCategories = async (query: string) => {
    //web-api/get_search_suggestions.php
    const hash = this.storage.userHash!
    const secure = this.secure.createUserSecure()
    return this.makeRequest.request<any, any>({
      api: 'v1/category_suggestions.php',
      body: {
        phrase: query,
        lang: this.storage.language,
        hash,
        secur: secure,
      },
      method: 'POST',
    })
  }

  fetchTree = async (
    responseInFlatStructure: boolean,
  ): Promise<RestResponse<Array<CACategoryModel>>> => {
    return this.makeRequest.newRequest<Array<CACategoryModel>>(
      {
        endpoint: 'v2/catalog/category/tree',
        data: {responseInFlatStructure},
        curlirize: false,
      },
      dataResponseConverter,
    )
  }

  fetchCategoryData = async (params: {
    id: number
    editFields?: FieldsModel
    excludeDependentFields?: boolean
  }): Promise<RestResponse<CACategoryDataModel>> => {
    return this.makeRequest.newRequest<CACategoryDataModel>(
      {
        endpoint: 'v2/catalog/category/data',
        data: {
          id: params.id,
          excludeDependentFields: params.excludeDependentFields ?? false,
          editFields: params.editFields,
        },
      },
      dataResponseConverter,
    )
  }

  fetchCatalogFieldDependent = async (
    dependenceSequenceId: number,
    dependenceSequence: Array<number>,
    otherValueWasSelected: boolean = false,
  ): Promise<RestResponse<CatalogFieldDependentResponse>> => {
    return await this.makeRequest.newRequest<CatalogFieldDependentResponse>(
      {
        endpoint: 'v2/catalog/field/dependent',
        data: {dependenceSequenceId, dependenceSequence, otherValueWasSelected},
      },
      dataResponseConverter,
    )
  }
}
